import React, { useState } from 'react'

import axios from 'axios';
import base64 from 'base-64'

import appMockup from '../app.png';
import bajaji from '../bajaji.png';

import '../App.css';

import Header from '../components/Header';

// Step Div component
function StepDiv(props) {
    return (
        <div className='stepDiv'>
            <h1 className="heading1">
                {props.stepNumber}. {props.stepTitle}
            </h1>

            {/* Form */}
            <p className='formHeader'>
                {props.stepDescription}
            </p>
        </div>
    );
}

function Home() {
    const [phone, setPhone] = useState('');
    const [sendText, setSendText] = useState('SEND');

    const api_key = "3cd45b8dd675cac9";
    const secret_key = "Y2FlNDczOTIzNmQ3NjlhNTAwYTkzNDNkZGEwZTA3ZGJhNGZmYTMyOTMyZTBmNGZiNjM1ODI0NDYyNDJiOGZmOA==";
    const content_type = "application/json";
    const source_addr = "OohBit";
    const message = "Start Earning Today: Download the app now\nhttps://drive.google.com/file/d/1tTKAWnLHh7pzPx6DKlVrs72ZnezVXQfn/view?usp=share_link\n\nDrive, Earn & Live."

    function Send(e) {
        e.preventDefault();
        setSendText('SENDING...')

        axios
            .post(
                "https://apisms.beem.africa/v1/send",
                {
                    source_addr: source_addr,
                    schedule_time: "",
                    encoding: 0,
                    message: message,
                    recipients: [
                        {
                            recipient_id: 1,
                            dest_addr: phone,
                        },
                    ],
                },
                {
                    headers: {
                        "Content-Type": content_type,
                        Authorization: "Basic " + base64.encode(api_key + ":" + secret_key),
                    },
                }
            )
            .then((response) => {
                console.log(response, api_key + ":" + secret_key)
                setSendText('SENT')
            })
            .catch((error) => console.error(error.response.data));
    }

    return (
        <div>
            <div className="App">
                <Header />

                {/* Hero */}
                <section id="home">
                    <div className='section hero'>

                        <div style={{ flex: 3 }}>
                            <h1 className="heading1">
                                Get paid to advertise<br></br> while you drive
                            </h1>
                            <h1 className="heading1">
                                It's a win-win!
                            </h1>

                            {/* Form */}
                            <p className='formHeader'>
                                It all starts with the OohBit app. <br></br>Sign Up now to get started!
                            </p>

                            <form style={{ display: 'none' }}>
                                <input
                                    type="tel"
                                    name="phone"
                                    placeholder='Phone Number (255)'
                                    className='phoneNumber'
                                    onChange={(e) => setPhone(e.target.value)}
                                />
                                <button onClick={(e) => Send(e)} type="submit" className='Send'>{sendText}</button>
                            </form>

                            <button type="button" className='Send'>
                                <a href='https://oohbit.herokuapp.com/driver/register' style={{ textDecoration: 'none', color: '#333' }}>{'SIGNUP NOW'}</a>
                            </button>

                        </div>

                        <div style={{ flex: 1 }}>
                            <img src={appMockup} className="appMockup" alt="App Mockup" />
                        </div>
                    </div>
                </section>

                {/* Steps */}
                <section>
                    <div className='section'>

                        <div style={{ flex: 3 }}>
                            <h1 className="heading2">
                                It's this easy...
                            </h1>

                            <StepDiv
                                stepNumber='1'
                                stepTitle='Download the app &#9989;'
                                stepDescription="It all starts with the OohBit app. Enter your number below and we'll text you a link to download it."
                            />

                            <StepDiv
                                stepNumber='2'
                                stepTitle='Sign up &#9889;'
                                stepDescription="Cruise through our few steps to complete your on-boarding process."
                            />

                            <StepDiv
                                stepNumber='3'
                                stepTitle='Receive Offers &#9203;'
                                stepDescription="When campaigns are available in your targeted area, you will see offers come into the app!"
                            />

                        </div>
                    </div>
                </section>

                {/* The Catch */}
                <section style={{ padding: "8%", marginTop: '5%', background: "#444", borderRadius: '30px' }}>
                    <div className='section-row'>
                        <div>
                            <h1 className="heading1">
                                Drivers  +  OohBit = Income Opportunity &#128184; <br></br>
                                <a href='#home' style={{ textDecoration: 'none' }}>
                                    <p className='formHeader-light'>
                                        &#128241;Get the app now...
                                    </p>
                                </a>
                            </h1>
                        </div>
                    </div>
                </section>

                {/* Earnings */}
                <section style={{ marginTop: "15%" }}>
                    <div className='section'>
                        <div style={{ flex: 1 }}>
                            <h1 className="heading1">
                                Earn from Tsh. 50,000 / month
                            </h1>
                            <p className="earningsDescription">
                                The amount you earn is based on the type of wrap you have on the vehicle & distance driven. The more kms, the more you earn!
                            </p>
                        </div>

                        <div style={{ flex: 2 }}>
                            <img src={bajaji} className="bajajiMockup" alt="Bajaji Mockup" />
                        </div>
                    </div>

                </section>

            </div>

            {/* Footer */}
            <section style={{ marginTop: "-15%", backgroundColor: "#444", padding: '10%' }}>
                <div className='section' style={{ alignItems: 'center' }}>
                    <div>
                        <h1 className="heading1-light">
                            Get started
                        </h1>
                    </div>

                    <div>
                        <p className='formHeader-light'>
                            Sign Up now, Download the app and start earning while you drive.
                        </p>

                        <form>
                            <button type="button" className='Send'>
                                <a href='https://oohbit.herokuapp.com/driver/register' style={{ textDecoration: 'none', color: '#333' }}>{'SIGNUP NOW'}</a>
                            </button>
                        </form>


                    </div>
                </div>

                <p className='oohbit-p'>
                    Visit us: <span className='oohbit'>info@oohbit.co.tz</span><br></br>
                    Call us: <span className='oohbit'>+255 763 144 515</span><br></br><br></br>
                    Copyright <span className='oohbit'>{new Date().getFullYear()}</span> OohBit
                </p>

            </section>

        </div>
    )
}

export default Home